import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { Home, Pill, User, LogOut } from 'lucide-react';
import { useAuth } from '@/lib/AuthContext';
import DisclaimerBanner from '@/components/DisclaimerBanner';

const NAV_ITEMS = [
  { to: '/home', label: 'Home', icon: Home, testId: 'nav-home' },
  { to: '/medications', label: 'Medications', icon: Pill, testId: 'nav-medications' },
  { to: '/profile', label: 'Profile', icon: User, testId: 'nav-profile' },
];

export default function AppLayout() {
  const { signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate('/welcome', { replace: true });
  };

  return (
    <div className="flex h-screen" style={{ backgroundColor: '#F7FAFC' }}>
      {/* Sidebar */}
      <aside className="hidden md:flex flex-col w-64 border-r shrink-0" style={{ backgroundColor: '#FFFFFF', borderColor: '#D7E2E8' }}>
        <div className="p-6 pb-4">
          <h1 className="text-xl font-extrabold tracking-tight" style={{ color: '#5B2D1F' }} data-testid="app-logo">
            Heritage Compass
          </h1>
        </div>
        <nav className="flex-1 px-3 space-y-1">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={item.testId}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-3 rounded-xl text-[15px] font-semibold transition-colors ${
                  isActive
                    ? 'text-white'
                    : 'hover:bg-[#EEF4F7]'
                }`
              }
              style={({ isActive }) =>
                isActive
                  ? { backgroundColor: '#D77A52', color: '#FFFFFF' }
                  : { color: '#4B6B79' }
              }
            >
              <item.icon className="h-5 w-5" />
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t" style={{ borderColor: '#D7E2E8' }}>
          <button
            onClick={handleSignOut}
            data-testid="sidebar-signout-btn"
            className="flex items-center gap-3 w-full px-3 py-3 rounded-xl text-[15px] font-semibold transition-colors hover:bg-red-50"
            style={{ color: '#B0303A' }}
          >
            <LogOut className="h-5 w-5" />
            Sign out
          </button>
        </div>
      </aside>

      {/* Main content */}
      <div className="flex-1 flex flex-col min-h-0 overflow-hidden">
        {/* Mobile top nav */}
        <header className="md:hidden flex items-center justify-between px-4 py-3 border-b" style={{ backgroundColor: '#FFFFFF', borderColor: '#D7E2E8' }}>
          <div className="flex items-center gap-2">
            <img src="/brand/logo-round.png" alt="" className="w-7 h-7 rounded-full" />
            <span className="text-lg font-extrabold" style={{ color: '#5B2D1F' }}>Heritage Compass</span>
          </div>
        </header>

        <DisclaimerBanner />

        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>

        {/* Mobile bottom tabs */}
        <nav className="md:hidden flex border-t" style={{ backgroundColor: '#FFFFFF', borderColor: '#D7E2E8' }}>
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`tab-${item.label.toLowerCase()}`}
              className="flex-1 flex flex-col items-center gap-1 py-2 text-xs font-semibold"
              style={({ isActive }) => ({
                color: isActive ? '#D77A52' : '#4B6B79',
              })}
            >
              <item.icon className="h-5 w-5" />
              {item.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </div>
  );
}
